import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DisplaysModule} from "../../_shared/displays/displays.module";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-boviclic-alert',
  standalone: true,
  imports: [
    DisplaysModule,
    NgIf
  ],
  templateUrl: './boviclic-alert.component.html',
  styleUrl: './boviclic-alert.component.css'
})
export class BoviclicAlertComponent {

  constructor(
    public dialogRef: MatDialogRef<BoviclicAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string; showContact: boolean, referer? : string }
  ) {}

  close(): void {
    this.dialogRef.close();
  }

}
